/**
 * Roles Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    contracts: [],
    contract: {},
    payments: [],
    paymentPrestation: {},
    guestContracts: []
};

// Getters
const getters = {
    contracts: function contracts(state) {
        return state.contracts;
    },

    guestContracts: function guestContracts(state) {
        return state.guestContracts;
    },

    contract: function contract(state) {
        return state.contract;
    },

    payments: function payments(state) {
        return state.payments;
    },
    paymentPrestation: function paymentPrestation(state) {
        return state.paymentPrestation;
    }
}
// Actions
var actions = {
    getPayments(context, payload) {
        function successCallback(response) {
            context.commit('getpaymentsHandler', { payments: response.data.payments });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getPaymentSouscripteur(context, payload) {
        function successCallback(response) {
            context.commit('getpaymentsHandler', { payments: response.data.payments });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.ListSouscripteur, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getPaymentsFromCIM(context, payload) {
        function successCallback(response) {
            context.commit('getpaymentsHandler', { payments: response.data.payments });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.Cim, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getPaymentPrestationStatus(context, payload) {
        function successCallback(response) {
            context.commit('getPaymentPrestationStatusHandler', { payment: response.data.statut });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.Statut, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getPaymentPrestation(context, payload) {
        function successCallback(response) {
            context.commit('getPaymentPrestationStatusHandler', { payment: response.data.payment });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getPaymentLink(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'show-pay-prestation', params: { id: response.data.url.uuid } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    updatePaymentPrestation(context, payload) {
        function successCallback(response) {
            Vue.swal(
                payload.successMessage,
                '',
                'success'
            );
            router.push({ name: 'show-pay-prestation', params: { id: response.data.payment.uuid } });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    deletePayment(context, payload) {
        function successCallback(response) {
            context.commit('deletePaymentHandler', { index: payload.index, successMessage: payload.successMessage });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Payment.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getContracts: function getContracts(context, payload) {
        function successCallback(response) {
            context.commit('getContractsHandler', { contracts: response.data.cims });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = localStorage.getItem('ms-token');

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].Contract.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getGuestContracts: function getGuestContracts(context, payload) {
        function successCallback(response) {
            context.commit('getGuestContractsHandler', { contrats: response.data.contrats });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];
        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.List, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    getContract: function getContract(context, payload) {
        function successCallback(response) {
            context.commit('getContractHandler', { contract: response.data.cim });
            context.commit('getcodeHandler', { code: response.data.code });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = localStorage.getItem('ms-token');

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].Contract.Get, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createContract: function createContract(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'success',
                text: payload.successMessage
            });

            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'contracts' });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = localStorage.getItem('ms-token');

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].Contract.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    infoSouscripteur: function infoSouscripteur(context, payload) {
        function successCallback(response) {
            context.commit('infoSouscripteurHandler', { souscripteur: response.data.souscripteur });
        }

        function errorCallback(error) {}
        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];
        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.InfoSoucripteur, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    createGuestContract: function createGuestContract(context, payload) {
        function successCallback(response) {
            // Vue.notify({
            //     type: 'success',
            //     text: payload.successMessage
            // });
            if (_.isNull(localStorage.getItem('visiteur'))) {
                Swal.fire(__WEBPACK_IMPORTED_MODULE_4__app__["default"].t('message.succes'), 'Un mail avec vos identifiants vous a été envoyé', 'success');
            }
            localStorage.setItem('visiteur', JSON.stringify(response.data.visiteur));
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'show-affiliation', params: { identifiant: response.data.contrat.contrat_code } });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = localStorage.getItem('ms-token');

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Create, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    authentifierVisiteur: function authentifierVisiteur(context, payload) {
        function successCallback(response) {
            localStorage.setItem('visiteur', JSON.stringify(response.data.visiteur));
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'affiliations' });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = '';

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Authentifier, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    updateGuestContract: function updateGuestContract(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'success',
                text: payload.successMessage
            });

            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'show-affiliation', params: { identifiant: response.data.cim.contrat_code } });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    paidContract: function paidContract(context, payload) {
        function successCallback(response) {
           // context.commit('getPatientHandler', { patient: response.data.patient });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');
        makeApiRequest(payload.args, apiModel.PaiementMethod.MomoPaid, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    paidContractByOM: function paidContractByOM(context, payload) {
        function successCallback(response) {
            // context.commit('getPatientHandler', { patient: response.data.patient });
         }
 
         function errorCallback(error) {
             Vue.swal(
                 payload.errorMessages.error,
                 '',
                 'error'
             );
         }
 
         const localToken = localStorage.getItem('ms-token');
         makeApiRequest(payload.args, apiModel.PaiementMethod.OmPaid, localToken, successCallback, errorCallback, payload.errorMessages);
     },
    backUpdateGuestContractStatut: function backUpdateGuestContractStatut(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'success',
                text: payload.successMessage
            });

            context.commit('getGuestContractHandler', { guestContract: response.data.contrat });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    modifierStatut: function modifierStatut(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'success',
                text: payload.successMessage
            });

            context.commit('getGuestContractsHandler', { contrats: response.data.contrats });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.UpdateStatus, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    backUpdateGuestContract: function backUpdateGuestContract(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'success',
                text: payload.successMessage
            });

            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'back-affiliation-show', params: { identifiant: response.data.cim.contrat_code } });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Update, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    sendGuestContract: function sendGuestContract(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'success',
                text: payload.successMessage
            });
            Swal.fire(__WEBPACK_IMPORTED_MODULE_4__app__["default"].t('message.succes'), __WEBPACK_IMPORTED_MODULE_4__app__["default"].t('message.copieContratEnvoye'), 'success');
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'remerciements' });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Send, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    sendPassword: function sendPassword(context, payload) {
        function successCallback(response) {
            Swal.fire(__WEBPACK_IMPORTED_MODULE_4__app__["default"].t('message.succes'), 'Un nouveau identifiant vous a été communiqué par mail', 'success');
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = '';

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.SendPassword, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    deleteGuestContract: function deleteGuestContract(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'guest' });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    },
    deleteGuestBackContract: function deleteGuestBackContract(context, payload) {
        function successCallback(response) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'success',
                text: payload.successMessage
            });
            context.commit('getGuestContractsHandler', { contrats: response.data.contrats });
            __WEBPACK_IMPORTED_MODULE_1__router__["a" /* default */].push({ name: 'affiliations' });
        }

        function errorCallback(error) {
            __WEBPACK_IMPORTED_MODULE_0_vue___default.a.notify({
                type: 'error',
                text: payload.errorMessages.error
            });
        }

        var localToken = JSON.parse(localStorage.getItem('visiteur'))['token'];

        Object(__WEBPACK_IMPORTED_MODULE_2__api__["b" /* makeApiRequest */])(payload.args, __WEBPACK_IMPORTED_MODULE_2__api__["a" /* apiModel */].GuestContract.Delete, localToken, successCallback, errorCallback, payload.errorMessages);
    }
};

// Mutations
const mutations = {
    getGuestContractsHandler: function getGuestContractsHandler(state, _ref2) {
        var contrats = _ref2.contrats;

        // Update contracts state
        state.guestContracts = contrats;
    },
    getpaymentsHandler(state, { payments }) {
        // Update reasons state
        state.payments = payments;
    },
    getPaymentPrestationStatusHandler(state, { payment }) {
        // Update payment state
        state.paymentPrestation = payment;
    },
    deletePaymentHandler(state, { index, successMessage }) {
        let i = state.payments.findIndex(payment => payment.id === index);

        if (~i) {
            state.payments.splice(i, 1);

            router.push({ name: 'pay-prestation' });

            Vue.swal(
                successMessage,
                '',
                'success'
            );
        }
    }   
};

export default {
    state,
    getters,
    actions,
    mutations
}
